export const tabData = [
  { title: 'ทั้งหมด', value: 'ALL' },
  { title: 'แสดง', value: 'SHOW' },
  { title: 'ซ่อน', value: 'HIDDEN' },
  { title: 'ซื้อแล้ว', value: 'BOUGHT' },
  { title: 'ยังไม่ซื้อ', value: 'NOT_BOUGHT' },
]
